import React from 'react';
import PropTypes from 'prop-types';

import withToggleView from '../../../Components/ToggleView/ToggleView';
import ItemField from '../../../Components/ItemField/ItemField';

const BlockRelations = ({ party, strings, mode, updatePartyId, id }) => {
  const getRelationField = relation => {
    const { type, to, id: relationId } = relation;
    switch (type.code) {
      case 'social_security_dependent':
        return (
          <ItemField
            label={strings['party.edit.field.social_security_dependent.label'] || type.name}
            value={to.id}
            name={type.code}
            key={`item-${relationId}`}
            type="inner-link"
            route={`/party/${to.id}`}
            onClick={() => updatePartyId(to.id)}
            optional
          />
        );
      case 'social_security_insured':
        return (
          <ItemField
            label={strings['party.edit.field.social_security_insured.label'] || type.name}
            value={to.id}
            name={type.code}
            key={`item-${relationId}`}
            type="inner-link"
            route={`/party/${to.id}`}
            onClick={() => updatePartyId(to.id)}
            optional
          />
        );
      default:
        return <ItemField label={type.name} value={to.id} name={type.code} key={`item-${relationId}`} optional />;
    }
  };

  const contentViewBlock = relations => (
    <div className="content" key={`relations-${id}`}>
      {Array.isArray(relations) ? relations.map(relation => getRelationField(relation)) : undefined}
    </div>
  );

  return mode === 'view' ? <>{contentViewBlock(party.relations)}</> : <div className="content">not available</div>;
};

BlockRelations.propTypes = {
  strings: PropTypes.objectOf(PropTypes.string),
  // eslint-disable-next-line react/forbid-prop-types
  party: PropTypes.object,
  mode: PropTypes.oneOf(['edit', 'view']).isRequired,
  updatePartyId: PropTypes.func.isRequired,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

BlockRelations.defaultProps = {
  party: {},
  strings: {},
};

const config = {
  title: 'party.edit.block.relations.label',
  defaultTitle: 'Relations',
  name: 'relations',
  active: false,
};

export default withToggleView(BlockRelations, config);
